import React, { useCallback, useContext, useMemo } from "react";
import ABMContext from "../context/ABMContext";
import InputText from "./inputs/InputText";
import Fecha from "./inputs/Fecha";
import InputSelect from "./inputs/InputSelect";
import InputCheckbox from "./inputs/InputCheckbox";
import InputRadio from "./inputs/RadioButton";
import InputFile from "./inputs/InputFile";
import AutocompletarABM from "./inputs/AutocompletarABM";
import InputPassword from "./inputs/InputPassword";
import Default from "../../Vista/components/columnas/Default";
import FechaSimple from "./inputs/Fecha_simple";
import Toggle from "./inputs/Toggle";
import InputBuscador from "./inputs/InputBuscador/InputBuscador";
import Hidden from "./inputs/Hidden";
import Enlace from "../../Vista/components/columnas/Enlace";
import { ReadOnlyTextArea } from "../../components/EditorTextArea";

import { ListadoProvider } from "../../Listado/Listado";

import ConfigListado from "../../Listado/components/ConfigListado";

const SwitchABM = (props) => {
  const { ABMDispatch, valorFormulario, opciones } = useContext(ABMContext);
  const { cab, data, id_elemento, qsBody, error, setError } = props;
  const campokey = cab.campo_alias ? cab.campo_alias : cab.id_a;

  const id_a = cab.id_a;

  const setFormularioValor = useCallback(
    (valor) => {
      setError((s) => {
        const ns = { ...s };
        ns[cab.id_a] = false;

        return ns;
      });

      if (cab.clave_envio && cab.clave_envio.trim() !== "") {
        ABMDispatch({
          type: "SET_FORMULARIO_VALOR",
          payload: { id_a: cab.clave_envio, valor },
        });
      }
      return ABMDispatch({
        type: "SET_FORMULARIO_VALOR",
        payload: { id_a, valor },
      });
    },
    [ABMDispatch, id_a, cab.clave_envio]
  );

  if (cab.round) {
    if (!isNaN(parseFloat(data[cab.id_a]))) {
      const val = Number.parseFloat(data[cab.id_a]).toFixed(
        parseInt(data[cab.id_a + "_round"] ?? cab.round)
      );
      data[cab.id_a] = val;
    }
  }

  const hijos =
    cab.sc_hijos?.length > 0
      ? cab.sc_hijos
          .sort((a, b) => a.orden - b.orden)
          .map((s, i) => (
            <SwitchABM
              key={s.id_a}
              data={data}
              indiceData={i}
              cab={s}
              padre={cab}
              id_elemento={s.id_a + i}
              error={error}
              setError={setError}
            />
          ))
      : null;

  const seleccionarDatosDeListado = useCallback(
    (rows, opcionesListado) => {
      const clave_envio =
        opcionesListado.clave_envio && opcionesListado.clave_envio.trim() !== ""
          ? opcionesListado.clave_envio
          : undefined;
      if (
        opcionesListado.listado_seleccion_data &&
        opcionesListado.listado_seleccion_data?.trim() !== ""
      ) {
        const extraer_idas = opcionesListado.listado_seleccion_data
          .split("|")
          .map((c) => c.trim());

        const data_extraida = rows
          .map((r) => {
            const rExtraido = extraer_idas.map((e) => r[e]);
            return rExtraido;
          })
          .join("|");

        if (clave_envio) {
          ABMDispatch({
            type: "SET_FORMULARIO_VALOR",
            payload: {
              id_a: clave_envio ?? opcionesListado.id_a,
              valor: [data_extraida],
            },
          });
        }
        ABMDispatch({
          type: "SET_FORMULARIO_VALOR",
          payload: {
            id_a: opcionesListado.id_a,
            valor: [data_extraida],
          },
        });
        return;
      }
      if (
        opciones.listado_seleccion_data &&
        opciones.listado_seleccion_data?.trim() !== ""
      ) {
        const extraer_idas = opciones.listado_seleccion_data
          .split("|")
          .map((c) => c.trim());

        const data_extraida = rows
          .map((r) => {
            const rExtraido = extraer_idas.map((e) => r[e]);
            return rExtraido;
          })
          .join("|");

        ABMDispatch({
          type: "SET_FORMULARIO_VALOR",
          payload: { id_a: clave_envio ?? "sideData", valor: [data_extraida] },
        });
      }
    },
    [opciones, ABMDispatch]
  );

  const renderListado = useMemo(() => {
    return (
      <div key={id_elemento} style={{ width: "100%", fontSize: "0.9rem" }}>
        <ListadoProvider
          key={cab.id_a}
          configuracion={cab}
          subirDatosSeleccionados={seleccionarDatosDeListado}
        >
          <ConfigListado />
        </ListadoProvider>
      </div>
    );
  }, [id_elemento, cab, seleccionarDatosDeListado]);

  const Componente = useMemo(
    () =>
      (() => {
        switch (data[`${cab.id_a}_COMPONENTE`] ?? cab.componente) {
          case undefined || "columna_simple":
            return (
              <Default
                key={cab.id_a}
                data={data}
                cab={cab}
                campokey={campokey}
                id_elemento={id_elemento}
              />
            );
          case "listado":
            return renderListado;
          case "input_text":
            return (
              <InputText
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                context={ABMContext}
                error={error}
                setError={setError}
              />
            );
          case "input_textarea":
            return (
              <InputText
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                textarea
                context={ABMContext}
                error={error}
                setError={setError}
              />
            );
          case "textarea":
            return (
              <ReadOnlyTextArea
                cab={props.cab}
                data={props.data}
                id_elemento={props.id_elemento}
                valor={valorFormulario[id_a]}
                context={ABMContext}
                error={error}
                setError={setError}
              />
            );
          case "input_number_editable":
            return (
              <InputText
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                number
                context={ABMContext}
                error={error}
                setError={setError}
              />
            );

          case "input_buscador":
            return (
              <InputBuscador
                key={cab.id_a}
                data={data}
                cab={cab}
                hijos={hijos}
                campokey={campokey}
                context={ABMContext}
                id_elemento={id_elemento}
                qsBody={qsBody}
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
              />
            );
          case "password":
            return (
              <InputPassword
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
              />
            );
          case "fecha":
            return (
              <Fecha
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
                cab={cab}
                data={data}
              />
            );
          case "fecha_simple":
            return (
              <FechaSimple
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
                cab={cab}
                data={data}
              />
            );
          case "input_fecha":
            return (
              <FechaSimple
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
                cab={cab}
                data={data}
              />
            );
          case "input_file":
            return (
              <InputFile
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
              />
            );
          case "select":
            // if (typeof valorFormulario[id_a] === "undefined") return <></>;
            return (
              <InputSelect
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
              />
            );
          case "si_no":
            // if (typeof valorFormulario[id_a] === "undefined") return <></>;
            cab.opciones = [
              { value: "s", label: "Si" },
              { value: "n", label: "No" },
            ];
            return (
              <InputSelect
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
              />
            );
          case "enum":
            // if (typeof valorFormulario[id_a] === "undefined") return <></>;
            return (
              <InputSelect
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
              />
            );
          case "checkbox":
            return (
              <InputCheckbox
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
              />
            );
          case "radio":
            return (
              <InputRadio
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
              />
            );
          case "autocompletar":
            return (
              <AutocompletarABM
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setError}
              />
            );
          case "toggle":
            return (
              <Toggle
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                id_elemento={id_elemento}
                error={error}
                setError={setError}
              />
            );
          case "grupo_columnas":
          case "div":
            return (
              <div
                className={`${data[cab.id_a + "_className"] ?? cab.className}`}
              >
                {hijos?.map((hijo) => hijo)}
              </div>
            );
          case "hidden":
            return (
              <Hidden
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                id_elemento={id_elemento}
                error={error}
                setError={setError}
              />
            );
          case "enlace":
            return (
              <Enlace
                key={cab.id_a}
                data={data}
                cab={cab}
                hijos={hijos}
                campokey={campokey}
                id_elemento={id_elemento}
              />
            );
          default:
            return <></>;
        }
      })(),
    [
      cab,
      campokey,
      data,
      hijos,
      id_a,
      id_elemento,
      props,
      qsBody,
      renderListado,
      setFormularioValor,
      valorFormulario,
    ]
  );

  if (
    data[`${cab.id_a}_COMPONENTE`] === "hidden" ||
    cab.componente === "hidden"
  ) {
    return <>{Componente}</>;
  }

  return (
    <>
      <div
        id={cab.id_a}
        style={{
          gridColumn: cab.grid_span,
          height: "100%",
          //  border: error[cab.id_a] ? "2px solid rgba(255,0,0,0.5)" : "",
          borderRadius: "2px"
        }}
        className={"switch_abm_input_base " + cab.className}
      >
        {Componente}
      </div>
      {/* <Obligatorio {...cab} /> */}
    </>
  );
};

export default React.memo(SwitchABM);
